var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalendarNegotiationNewIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    width: 65.625,
    height: 65.625,
    rx: 6.5625,
    fill: "#EBF6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1770_522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 41,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8125,
    y: 13.125,
    width: 39.375,
    height: 39.375,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1770_522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0156 26.25H44.9844V22.9688H22.0156V26.25ZM22.0156 49.2188C21.1133 49.2188 20.3408 48.8975 19.6982 48.2549C19.0557 47.6123 18.7344 46.8398 18.7344 45.9375V22.9688C18.7344 22.0664 19.0557 21.2939 19.6982 20.6514C20.3408 20.0088 21.1133 19.6875 22.0156 19.6875H23.6562V16.4062H26.9375V19.6875H40.0625V16.4062H43.3438V19.6875H44.9844C45.8867 19.6875 46.6592 20.0088 47.3018 20.6514C47.9443 21.2939 48.2656 22.0664 48.2656 22.9688V32.2793C47.7461 32.0332 47.2129 31.8281 46.666 31.6641C46.1191 31.5 45.5586 31.377 44.9844 31.2949V29.5312H22.0156V45.9375H32.3516C32.543 46.5391 32.7686 47.1133 33.0283 47.6602C33.2881 48.207 33.5957 48.7266 33.9512 49.2188H22.0156ZM43.3438 50.8594C41.0742 50.8594 39.1397 50.0596 37.54 48.46C35.9404 46.8604 35.1406 44.9258 35.1406 42.6562C35.1406 40.3867 35.9404 38.4522 37.54 36.8525C39.1397 35.2529 41.0742 34.4531 43.3438 34.4531C45.6133 34.4531 47.5479 35.2529 49.1475 36.8525C50.7471 38.4522 51.5469 40.3867 51.5469 42.6562C51.5469 44.9258 50.7471 46.8604 49.1475 48.46C47.5479 50.0596 45.6133 50.8594 43.3438 50.8594ZM46.0918 46.5527L47.2402 45.4043L44.1641 42.3281V37.7344H42.5234V42.9844L46.0918 46.5527Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarNegotiationNewIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-negotiation-new-icon.764a1953.svg";
export { ForwardRef as ReactComponent };